import { render, staticRenderFns } from "./monitoring-service.vue?vue&type=template&id=54540b32&scoped=true"
import script from "./monitoring-service.vue?vue&type=script&lang=js"
export * from "./monitoring-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54540b32",
  null
  
)

export default component.exports